import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import RecordNotFound from '../../../../components/Reusable/RecordNotFound';

import DurationDisplay from '../DurationDisplay';

const DistributionChart = ({
  title = "Distribution",
  categories = [],
  seriesData = [],
  seriesName = "Count",
  series = null,
  stacked = false,
  durationProps
}) => {
  // 1. Logic to check if data exists
  const hasData = useMemo(() => {
    if (series) {
      return series.some(s => s.data && s.data.length > 0);
    }
    return seriesData && seriesData.length > 0;
  }, [series, seriesData]);

  const dynamicHeight = useMemo(() => {
    const calculatedHeight = (categories.length * 40) + 100;
    return Math.max(calculatedHeight, 350);
  }, [categories]);

  const chartConfig = useMemo(() => {
    if (!hasData) return null;

    return {
      series: series ?? [{
        name: seriesName,
        data: seriesData
      }],
      options: {
        chart: {
          type: 'bar',
          stacked: stacked,
          height: '100%',
          toolbar: {
            show: true,
            export: {
              csv: { show: false },
              svg: { show: true },
              png: { show: true },
            }
          },
          animations: { enabled: false }
        },
        colors: !stacked ? ['#242656'] : ['#242656', '#FF6B6B', '#4ECDC4', '#FFA500', '#6A5ACD'],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            barHeight: '70%',
            dataLabels: { position: 'top' },
          }
        },
        dataLabels: {
          enabled: false,
          offsetX: 30,
          style: { fontSize: '12px', colors: ['#304758'] },
          formatter: (val) => val,
        },
        xaxis: {
          categories: categories,
          position: 'bottom',
          labels: { formatter: (val) => Math.floor(val) },
          axisBorder: { show: false }
        },
        yaxis: {
          labels: {
            show: true,
            maxWidth: 220,
            minWidth: 220,
            style: { fontWeight: 600, fontSize: '11px' },
            formatter: function (val) {
              if (typeof val === 'string' && val.length > 35) {
                const words = val.split(' ');
                const lines = [];
                let currentLine = '';
                words.forEach(word => {
                  if ((currentLine + word).length > 35) {
                    lines.push(currentLine.trim());
                    currentLine = word + ' ';
                  } else {
                    currentLine += word + ' ';
                  }
                });
                lines.push(currentLine.trim());
                return lines;
              }
              return val;
            }
          }
        },
        grid: {
          xaxis: { lines: { show: true } },
          yaxis: { lines: { show: false } }
        },
        tooltip: { enabled: true }
      }
    };
  }, [categories, seriesData, seriesName, series, stacked, hasData]);

  return (
    <div style={{ background: '#fff', padding: 20, borderRadius: 8 }}>
      <h1 className='heading-sm'>{title}</h1>
      
      {!hasData ? (
        <RecordNotFound text={`No data available for ${title}`} />
      ) : (
        <div style={{ height: dynamicHeight }}>
          <ReactApexChart
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height="100%"
          />
        </div>
      )}
      {durationProps && (
        <DurationDisplay
          dateType={durationProps.dateType}
          dateRangeLabel={durationProps.dateRangeLabel}
          dateRangeTooltip={durationProps.dateRangeTooltip}
          dateRangeDetail={durationProps.dateRangeDetail}
          monthsCount={durationProps.monthsCount}
        />
      )}
    </div>
  );
};

export default DistributionChart;








// import React, { useMemo } from 'react';
// import ReactApexChart from 'react-apexcharts';

// const DistributionChart = ({
//   title = "Distribution",
//   categories = [],
//   seriesData = [],
//   seriesName = "Count"
// }) => {

//   const dynamicHeight = useMemo(() => {
//     const calculatedHeight = (categories.length * 40) + 100;
//     return Math.max(calculatedHeight, 350);
//   }, [categories]);

//   const chartConfig = useMemo(() => {
//     return {
//       series: [{
//         name: seriesName,
//         data: seriesData
//       }],
//       options: {
//         chart: {
//           type: 'bar',
//           height: '100%',
//           toolbar: {
//             show: true,
//             export: {
//               csv: { show: false },
//               svg: { show: true },
//               png: { show: true },
//             }
//           },
//           animations: { enabled: false }
//         },
//         colors: ['#242656'],
//         plotOptions: {
//           bar: {
//             borderRadius: 4,
//             horizontal: true,
//             barHeight: '70%',
//             dataLabels: {
//               position: 'top',
//             },
//           }
//         },
//         dataLabels: {
//           enabled: false,
//           offsetX: 30,
//           style: {
//             fontSize: '12px',
//             colors: ['#304758'],
//           },
//           formatter: (val) => val,
//         },
//         xaxis: {
//           categories: categories,
//           position: 'bottom',
//           labels: {
//             formatter: (val) => Math.floor(val)
//           },
//           axisBorder: { show: false }
//         },
//         yaxis: {
//           labels: {
//             show: true,
//             maxWidth: 220,
//             minWidth: 220,
//             // align: 'right',
//             style: {
//               fontWeight: 600,
//               fontSize: '11px',
//             },
//             // This function splits the text into multiple lines
//             formatter: function (val) {
//               if (typeof val === 'string' && val.length > 35) {
//                 // Splitting by space ensures words aren't cut in half
//                 const words = val.split(' ');
//                 const lines = [];
//                 let currentLine = '';

//                 words.forEach(word => {
//                   if ((currentLine + word).length > 35) {
//                     lines.push(currentLine.trim());
//                     currentLine = word + ' ';
//                   } else {
//                     currentLine += word + ' ';
//                   }
//                 });
//                 lines.push(currentLine.trim());
//                 return lines; // ApexCharts renders an array as multiple lines
//               }
//               return val;
//             }
//           }
//         },
//         grid: {
//           xaxis: { lines: { show: true } },
//           yaxis: { lines: { show: false } }
//         },
//         tooltip: { enabled: true }
//       }
//     };
//   }, [categories, seriesData, seriesName]);

//   return (
//     <div id="chart" style={{
//       background: '#fff',
//       padding: '20px',
//       borderRadius: '8px',
//       // Ensure the container handles the height
//       minHeight: '350px'
//     }}>
//       <h1 className='heading-sm'>{title}</h1>
//       <div style={{ height: dynamicHeight }}>
//         <ReactApexChart
//           options={chartConfig.options}
//           series={chartConfig.series}
//           type="bar"
//           height="100%"
//         />
//       </div>
//     </div>
//   );
// };

// export default DistributionChart;